<!--
  @description 部门首页事项模板1
  @author cjs1992
  @date 2020-10-22 13:14:45
-->
<template>
  <div class="guideline_item_father">
    <!-- 遍历事项列表 -->
    <template v-for="(item, index) in guidelineList">
      <div
        class="guideline_item"
        :key="index"
      >
        <div class="guideline_item_wrap">
          <div style="display: flex;align-items: center;">
            <img
              :src="`/portal-ywtb/${item.guidelineImg}`"
              style="width: 48px;height: 48px;margin-right:10px;"
            />
            <div>
              <div class="mutil-line-ellipsis">
                <span class="guideline_name">{{item.portalPcHandlingGuidelineName}}</span>
              </div>
              <div class="rate_wrap">
                <!-- <el-rate
	              :value="item.guidelineSatisfaction || 0"
	              disabled
	            >
	            </el-rate> -->
                <Rate
                  :value="item.guidelineSatisfaction || 0"
                  disabled
                >
                </Rate>
              </div>
            </div>
          </div>
          <!-- 下方操作 -->
          <div class="item_ope_wrap">
            <div
              class="ope_item bszn"
              @click="bsznFunc(item)"
              v-if="String(item.portalPcHandlingGuideline) === '1'"
            >
              <i class="iconfont icon-banshizhinan"></i>办事指南
            </div>
            <div
              class="ope_item"
              :class="{
                'borderLeft': String(item.portalPcHandlingGuideline) === '1'
              }"
              @click="zxblFunc(item)"
              v-if="[ null, undefined, '' ].indexOf(item.guidelineUrl) === -1 && item.ljbl === 1"
            >
              <i class="iconfont icon-banli"></i>在线办理
            </div>
            <template v-if="$store.state.isLogin">
              <div
                class="ope_item active"
                :class="{
                  'borderLeft': [ null, undefined, '' ].indexOf(item.guidelineUrl) === -1 && item.ljbl === 1 || String(item.portalPcHandlingGuideline) === '1'
                }"
                v-if="item.portalPcHandlingGuidelineCollection === 1"
                @click="scFunc(item)"
              >
                <i class="iconfont icon-sc"></i>取消收藏
              </div>
              <div
                class="ope_item"
                :class="{
                  'borderLeft': [ null, undefined, '' ].indexOf(item.guidelineUrl) === -1 && item.ljbl === 1 || String(item.portalPcHandlingGuideline) === '1'
                }"
                v-else
                @click="scFunc(item)"
              >
                <i class="iconfont icon-sc"></i>我要收藏
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Rate from "@/components/rate/main.vue";
export default {
  components: {
    Rate
  },
  props: {
    guidelineList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  inject: ["bsznFunc", "zxblFunc", "scFunc"],
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.guideline_item_father {
  margin: 0 -9px;
}
.guideline_item {
  width: 388px;
  height: 150px;
  border: 1px solid #e0e0e0;
  // border-top-width: 2px;
  display: inline-block;
  vertical-align: top;
  margin: 0 9px 20px;
  box-sizing: border-box;
  padding: 20px 28px;
  .guideline_name {
    color: #5a5a5a;
    font-size: 16px;
  }
  transition: all linear 0.3s;
  &:hover {
    border-color: transparent;
    border-top: 2px solid #4172dd;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  }
}
.rate_wrap {
  position: relative;
  padding: 10px 0 10px;
  &::before {
    content: " ";
    position: absolute;
    background-color: transparent;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }
  /deep/ {
    .el-rate__item {
      width: 28px;
    }
    .el-rate__icon.el-icon-star-off {
      font-size: 14px;
      color: #ffb32e !important;
    }
    .el-icon-star-on {
      font-size: 16px;
    }
  }
}
.item_ope_wrap {
  font-size: 0;
  .ope_item {
    display: inline-block;
    height: 16px;
    width: 110px;
    font-size: 12px;
    color: #abb1b6;
    line-height: 16px;
    cursor: pointer;
    &:hover {
      color: #4172dd;
    }
    // &.bszn {
    width: 94px;
    // }
    box-sizing: border-box;
    .iconfont {
      font-size: 14px;
      margin-right: 4px;
    }
    &.borderLeft {
      width: 110px;
      border-left: 1px solid #b6b6b6;
      text-align: center;
      &.active {
        .iconfont {
          color: #f7ba2a !important;
        }
      }
    }
  }
}
.mutil-line-ellipsis {
  width: 100%;
  height: 40px;
  line-height: 20px;
  // margin: 20px 20px 50px 300px;
  border: 0px solid #aaa;
  line-height: 20px;
  overflow: hidden;
}
/*相当于之前的prop*/
.mutil-line-ellipsis:before {
  content: "";
  float: left;
  width: 5px; /*缩小宽度为5px，其余属性不变*/
  height: 50px;
}
/*相当于之前的main*/
.mutil-line-ellipsis > :first-child {
  float: right;
  width: 100%;
  margin-left: -5px; /*让main元素左移5px，这样main元素在宽度上就完全占满了父元素；*/
  word-break: break-all;
}
/*相当于之前的realEnd*/
.mutil-line-ellipsis:after {
  content: "...";
  box-sizing: content-box;
  float: right;
  position: relative;
  width: 50px;
  height: 25px;
  top: -28px; /*等于高度的负值，就是文字的行高*/
  left: 100%;
  /*而设置margin-left: -50px、padding-right: 5px则是为了让realend元素的盒模型的最终宽度计算为5px。*/
  margin-left: -50px;
  padding-right: 5px;
  font-size: 13px;
  text-align: right;
  // background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff 40px);
  background-color: #fff;
  width: 25px;
  margin-left: -25px;
  text-align: left;
  text-indent: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/dept-home-guideline/template-3.vue